export const EVENT = 'Event';
export const BLOCK_DAY = 'Block day';

export default Object.freeze({
  EVENT,
  BLOCK_DAY
});
